import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { ProvisaoRecursoLista } from "../../models/provisao_recurso_lista";
import { IGetAllProvisaoRecursoUseCase } from "../../../presentation/useCases/read/get_all_qualidade_provisao_recurso_use_case";
import { ProvisaoRecursoFilter } from "../../models/provisao_recurso_filter";


// GetAllQualidadeCronogramaSGQServicoUseCase


export class GetAllQualidadeProvisaoRecursoServicoUseCase
  extends BasePaginatedUseCase<ProvisaoRecursoLista>
  implements IGetAllProvisaoRecursoUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemProvisaoRecurso(
    filter: ProvisaoRecursoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    
    const response = await this.repository
      .getAllListagemProvisaoRecurso(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
